// extracted by mini-css-extract-plugin
module.exports = {"container":"TableCouponsActions_container__2pPx0","link":"TableCouponsActions_link__3MGlj","span":"TableCouponsActions_span__Za8cg","icon":"TableCouponsActions_icon__3-e7f"};